// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CommentStatus = {
    Pending: 'PENDING',
    Resolved: 'RESOLVED',
    Rejected: 'REJECTED'
} as const;
export type CommentStatus = typeof CommentStatus[keyof typeof CommentStatus];


export function instanceOfCommentStatus(value: any): boolean {
    for (const key in CommentStatus) {
        if (Object.prototype.hasOwnProperty.call(CommentStatus, key)) {
            if (CommentStatus[key as keyof typeof CommentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CommentStatusFromJSON(json: any): CommentStatus {
    return CommentStatusFromJSONTyped(json, false);
}

export function CommentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentStatus {
    return json as CommentStatus;
}

export function CommentStatusToJSON(value?: CommentStatus | null): any {
    return value as any;
}

export function CommentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CommentStatus {
    return value as CommentStatus;
}
